
import Vue from "vue";
import { HotlistType, Hotlist }  from '../../../types/Sapphire_dto';
import axios from "axios";

export default Vue.extend({
    name: "dashboard-patient-hotlist",
    props: {
        fac: String
    },
    data: function () {
        return {
            widthModifier: 'one-third',
            heightModifier: '',
            selectedHotlist: null as Hotlist,
            listTypes: [] as HotlistType[],
            patients: [] as Hotlist[]
          
        };
    },
    computed: {
        dashboardWidthModifier(): string {
            return 'dashboard-' + this.widthModifier + '-item-div';
        },
    },
    watch: {
      fac: function(newVal, oldVal) {
            if (newVal != oldVal) {
                this.loadData();
            }
      },
      selectedHotlist:function(newVal, oldVal) {
            if (newVal != oldVal) {  
            this.updateHotlists();
            }
      }
    },
    methods: {
      formatPatientLink: function (item) {
            return "PatientChartPage.aspx?pid=" + item.patientID;
        },

      async loadData() {
           
            try {
                const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetHotlistTypes"
                );

                this.listTypes = JSON.parse(response.data.d);
                this.updateHotlists();
            } catch (err) {
                //this.isErrored = true;
            }
            
       },

      async updateHotlists() {
        try {
                const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetHotlistsByHotlistTypeID",
                {
                  hotlistTypeID: this.selectedHotlist ? this.selectedHotlist.id : 0,
                  facilityID: this.fac
                }
                );

                this.patients = JSON.parse(response.data.d);
                
            } catch (err) {
                //this.isErrored = true;
            }
      }
    },
});
